import React, { useEffect,useState } from 'react'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear , faCirclePlus ,faMoneyBills} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import ConnectModal from '../../components/ConnectModal';
import { toast } from 'react-hot-toast';
import { ReactSession } from 'react-client-session';
import { RefEarnedBalance } from '../../hooks/useContractFactory';
import MenuButtons from '../../components/MenuButtons';


function RefProgram() {

    document.title = "Altcoinator | Referral Program";
 
  const { account , connect } = useWallet();

  const earnedBalance = RefEarnedBalance()/1e18;

 const ConnectWalletOnclick = ()=>{

        const ethereum = window.ethereum;
        if(ethereum){

         
          if(!account){
              connect("injected");
            }        

        } else {
          toast.error("Please Install Metamask");
        }
        
      }
 
     return ( 
        <>
        <div id="wrapper">
          <Header />
          
          <section className="tf-section tf-wallet"  >
            <div style={{maxWidth:"760px"}} className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="wallet-form">
                   <MenuButtons/>
                     
                    <hr/>
                       
                    <h4>Refferal Program</h4>
                    <hr/>
                    

                    {account ? <>

                   <h5> Total Earned: <br/>  {earnedBalance} {ReactSession.get("network").symbol} </h5>
                        
                        <div className='alert alert-info'>
                    You can generate income with the referral program. You can earn additional income by sharing your referral link or adding code to your site as a banner. 
                    "<b>10%</b>" per token creation will be reflected in your account as a bonus. When the token is created through your referral, the money you earn will be automatically sent to your wallet.
                    </div>
                    <hr/>
                    Your Refferal Url:
                    
                    <div className='row mt-3'>
                        <div className='col-lg-9'>
                            <input type="text" disabled  value={"https://altcoinator.com/ref/"+account} required style={{background:"#171F29"}} />
                        </div>
                        <div className='col-lg-3'>
                             <button type="button"  onClick={()=>{navigator.clipboard.writeText("https://altcoinator.com/ref/"+account); toast.success("Url Copied")}} className="tf-button style2 w-100">
                                    Copy
                            </button>
                        </div>
                    </div>
                    <hr/>
                   
                        Banner Code:
                    <div className='row mt-3'>
                        <div className='col-lg-9'>
                        <textarea disabled style={{background:"#171F29",height:"120px"}} value={"<a target='_blank' href='https://altcoinator.com/ref/"+account+"' ><img src='https://altcoinator.com/assets/images/banner.gif'/></a>"} />
                        </div>
                        <div className='col-lg-3'>
                             <button type="button"  onClick={()=>{navigator.clipboard.writeText("<a target='_blank' href='https://altcoinator.com/ref/"+account+"' ><img src='https://altcoinator.com/assets/images/banner.gif'/></a>"); toast.success("Code Copied")}} className="tf-button style2 w-100">
                                    Copy
                            </button>
                        </div>
                    </div>
                    <br/>
                    <img src='https://altcoinator.com/assets/images/banner.gif' />
                    </> : (
                    <>
                        <div className="wrap-btn">
                            <button type="button" onClick={ConnectWalletOnclick} className="tf-button style2 w-100">
                                    Connect Wallet
                            </button>
                        </div>
                        <ConnectModal/>
                    </>
                    )}
                    
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Footer/>
      </> 
  ); 

} 

export default RefProgram;
